import * as React from 'react';

import {useTranslation} from 'common/i18n/hooks';
import {ButtonReact} from 'common/components/button';
import {ButtonTheme} from 'common/components/button/constants';
import {events, properties, track} from 'common/report/util/settings-tracking';
import {AddOnFeatureGateName} from 'iron/apps/settings/src/mixpanel-settings/screens/org/plan-builder/utils';

export function upgradePlan(
  source: string,
  modifyPlan: (addOnFeatureGateName?: AddOnFeatureGateName) => void,
  hasInProductPlanBuilderFeatureFlag = false,
  addOnFeatureGateName?: AddOnFeatureGateName,
) {
  track(events.clickUpgradePlan, {[properties.source]: source, [properties.onNewPlanDetails]: true});
  if (hasInProductPlanBuilderFeatureFlag) {
    modifyPlan(addOnFeatureGateName);
  } else {
    window.open(`/pricing/plan-builder/?dcv=growth/`, `_blank`);
  }
}

export function UpgradePlanButton({
  source,
  modifyPlan,
  hasInProductPlanBuilderOrgFF,
  className = ``,
}: {
  source: string;
  modifyPlan: () => void;
  hasInProductPlanBuilderOrgFF?: boolean;
  className?: string;
}) {
  const i18n = useTranslation();

  return (
    <ButtonReact
      icon='gem'
      theme={ButtonTheme.Upgrade}
      onClick={() => upgradePlan(source, modifyPlan, hasInProductPlanBuilderOrgFF)}
      class={className}
    >
      {i18n.t(`settings.org-settings.plan-details-new.upgrade-plan`)}
    </ButtonReact>
  );
}
